import firebase from '../../firebase';

export default async function createUser(params) {
    const user = await firebase.functions().httpsCallable('users-create')(params);
    if (user && user.data) {
        return user.data;
    }
    return null;
}
